module.exports = require("@swa-ui/itinerary/src/ItineraryRecentSearch/ItineraryRecentSearch.module.scss");